import React from 'react';
import {useSelector} from "react-redux";
import ProductListUi, {ProductListUiNoRedux} from "./ProductListUi";

const ProductListByValue = ({mobile, value, type, title, image, imageWeb, noRedux = false, isNavOverlay, ...props}) => {


  const getImage = mobile ? (image ?? imageWeb) : (imageWeb ?? image);

  return (
    <div className="w-full grid product-special app-top-mg" {...props}>
      {!!getImage && <div className={`${mobile ? "" : "web "}w-full app-side-pd grid-area`}>
        <div
          className={`w-full bg-rand-200 ${mobile ? "aspect-focused-banner" : "aspect-ratio-special-banner_web"} app-rounded shadow-md`}
          style={{
            backgroundImage: `url(${getImage})`,
            backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center"
          }}
        />

      </div>}

      {noRedux ? <ProductListUiNoRedux isNavOverlay={isNavOverlay}
          className={image ? (mobile ? "pt-2 grid-area min-w-0" : "pt-4") : (mobile ? "pt-2" : "pt-4")}
          title={title} value={value}
          type={type} mobile={mobile} isCampaign={getImage}
          viewButtonColor={image ? "text-dark" : "text-quaternary"}/> :
        <_ProductListByValue  title={title} mobile={mobile} value={value} type={type} image={getImage} isNavOverlay={isNavOverlay}/>}

    </div>

  );
};

export default React.memo(ProductListByValue);

const _ProductListByValue = ({mobile, value, type, title, image, isNavOverlay}) => {

  const {[`${type}-${value}`]: productData} =
    useSelector((state) => state.dynamicMultipleElements.products);


  return (

    <ProductListUi productData={productData}
                   className={image ? (mobile ? "pt-2 grid-area min-w-0" : "pt-4") : (mobile ? "pt-2" : "pt-4")}
                   title={title} value={value} isNavOverlay={isNavOverlay}
                   type={type} mobile={mobile} isCampaign={image}
                   viewButtonColor={image ? "text-dark" : "text-quaternary"}/>


  );
};

